import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDebouncedCallback } from 'use-debounce';
import LayoutProvider from '../../../../Contexts/LayoutProvider';
import PageTitle from '../../../../utils/PageTitle';
import { mkRelativeUrl } from '../../../../utils/URL';
import InvoiceListPageHeader from './components/QuotationListPageHeader';
import InvoiceListPageHeaderMobile from './components/QuotationListPageHeaderMobile';
import QuotationListTable from './components/QuotationListTable';
import QuotationListTableMobile from './components/QuotationListTableMobile';
import QuotationListProvider, { useBillingQuotation } from './QuotationListProvider';

function PageCont() {
    const navigate = useNavigate();
    const { quotationData, setParams } = useBillingQuotation();
    // Search Params
    const [searchParams] = useSearchParams();
    const [queryStr, setQueryStr] = useState({ q: searchParams.get('q') || '' });
    const p = useMemo(
        () => ({
            q: searchParams.get('q') || '',
            status: searchParams.get('status') || '',
            'order-by': searchParams.get('order-by') || 'id',
            sort: searchParams.get('sort') || 'desc',
            page: searchParams.get('page')
        }),
        [searchParams]
    );

    const debounceUpdate = useDebouncedCallback((val) => {
        navigate(mkRelativeUrl('/billing/quotations', { ...p, q: val }));
    }, 400);

    const handleChangeFilterData = (e) => {
        const { name, value } = e.target;
        if (name) {
            if (name === 'q') {
                setQueryStr({ q: value });
                debounceUpdate(value);
            } else {
                navigate(mkRelativeUrl('/billing/quotations', { ...p, [name]: value }));
            }
        }
    };
    const onChangePage = (page) => {
        navigate(mkRelativeUrl('/billing/quotations', { ...p, page }));
    };

    // For mobile view reset filter
    const onResetFilter = () => {
        navigate(mkRelativeUrl('/billing/quotations', { q: '', status: '' }));
    };

    const handleSortingData = (column) => {
        navigate(
            mkRelativeUrl('/billing/quotations', {
                ...p,
                'order-by': column,
                sort: p.sort === 'desc' ? 'asc' : 'desc'
            })
        );
    };

    useEffect(() => {
        setParams(p);
    }, [p, setParams]);

    return (
        <div className="inner_page_cont">
            <LayoutProvider>
                <InvoiceListPageHeader
                    layout="default"
                    onChangeHandler={handleChangeFilterData}
                    p={{ ...p, ...queryStr }}
                />
                <InvoiceListPageHeaderMobile
                    layout={['md', 'sm', 'xs', 'xxs']}
                    onResetFilter={onResetFilter}
                    onChangeHandler={handleChangeFilterData}
                    p={{ ...p, ...queryStr }}
                />
            </LayoutProvider>

            <LayoutProvider>
                <QuotationListTable
                    onSortedHandler={handleSortingData}
                    sortedColumn={p['order-by']}
                    sortBy={p.sort}
                    layout="default"
                    data={quotationData}
                    onChangePage={onChangePage}
                />
                <QuotationListTableMobile layout={['md', 'sm', 'xs', 'xxs']} data={quotationData} />
            </LayoutProvider>
        </div>
    );
}

function QuotationListPage() {
    // set page title
    PageTitle(`Quotation List`);

    return (
        <QuotationListProvider>
            <PageCont />
        </QuotationListProvider>
    );
}

export default QuotationListPage;
